import { Card, CardContent } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { hardwareFinishes, handleStyles } from '../constants';

const HardwareStep = ({ config, updateConfig }) => (
  <div>
    <h3 className="text-xl font-semibold mb-6">Select Hardware Options</h3>

    <div className="mb-8">
      <h4 className="font-medium mb-3">Hardware Finish</h4>
      <div className="flex flex-wrap gap-3">
        {hardwareFinishes.map((finish) => (
          <Card
            key={finish.id}
            data-testid={`finish-${finish.id}`}
            className={`cursor-pointer transition-all ${config.hardwareFinish === finish.id ? 'ring-2 ring-primary' : 'hover:ring-1 hover:ring-primary/50'}`}
            onClick={() => updateConfig('hardwareFinish', finish.id)}
          >
            <CardContent className="p-4 flex items-center gap-3">
              <div className="w-8 h-8 rounded-full border-2 border-gray-200" style={{ backgroundColor: finish.color }} />
              <span className="font-medium text-sm">{finish.name}</span>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>

    <div className="mb-8">
      <h4 className="font-medium mb-3">Handle Style</h4>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {handleStyles.map((handle) => (
          <Card
            key={handle.id}
            data-testid={`handle-${handle.id}`}
            className={`cursor-pointer transition-all ${config.handleStyle === handle.id ? 'ring-2 ring-primary' : 'hover:ring-1 hover:ring-primary/50'}`}
            onClick={() => updateConfig('handleStyle', handle.id)}
          >
            <CardContent className="p-4 text-center">
              <span className="font-medium">{handle.name}</span>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>

    <div>
      <h4 className="font-medium mb-3">Additional Notes</h4>
      <Textarea
        data-testid="additional-notes"
        placeholder="Any special requirements, existing conditions, or questions..."
        value={config.additionalNotes}
        onChange={(e) => updateConfig('additionalNotes', e.target.value)}
        rows={3}
      />
    </div>
  </div>
);

export default HardwareStep;
